import React from 'react';
import { Chip } from '@mui/material';
import { i18n, Text, Theme, tokens } from '@simplybenefits/sb-ui-library';
import { helpers } from "@simplybenefits/sb-utils";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { 
    Add as AddIcon, 
    Remove as RemoveIcon 
} from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function Dental({ classes, expanded, dental, handleChange, defineDeductibleVerbiage, showDependentWarning, waivedDental, isStudent }) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('dental')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('dental') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>Dental</Text>
                    {
                        waivedDental &&
                            <Chip
                                size="small"
                                label="Waived"
                                color="primary"
                                variant="outlined"
                                style={{
                                    margin: "0 10px",
                                    borderRadius: 30,
                                    borderWidth: 2,
                                    borderColor: Theme.colors.lightGrey,
                                    fontFamily: Theme.fonts.type.heading,
                                    fontSize: 14,
                                    color: '#666'
                                }}
                            />
                    }
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    {
                        dental.isEligible !== 1 ?
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You are currently ineligible for this benefit, if this is a mistake please contact your administrator.
                                </Text>
                            </div>
                            : null
                    }

                    {
                        showDependentWarning &&
                            <div style={classes.row}>
                                <Text small bold margin="20px 0px 10px 0px">
                                    You have waived this benefit for your dependents.
                                </Text>
                            </div>
                    }

                    <div style={{ marginBottom: 10 }}>
                        {dental.combineBasicAndMajor ?
                            <Text small bold margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(dental.basicMajorCombinedMax) } annual maximum for Basic and Major procedures.` }</Text>
                            :
                            <React.Fragment>
                                {
                                    dental.includeMajor ?
                                        <Text small bold margin="5px 0px 0px 0px">{ dental.majorMax > 0 ? `$${ helpers.formatNumber(dental.majorMax) } annual maximum for Major procedures.` : null }</Text>
                                        : null
                                }
                                {
                                    dental.includeBasic ?
                                        <Text small bold margin="5px 0px 0px 0px">{ dental.basicMax > 0 ? `$${ helpers.formatNumber(dental.basicMax) } annual maximum for Basic procedures.` : null }</Text>
                                        : null
                                }
                            </React.Fragment>
                        }
                    </div>

                    {
                        (dental.familyCombinedMaximum && dental.familyCombinedMaximum !== 0) ?
                            <div style={classes.row}>
                                <Text small bold margin="10px 0px 10px 0px">
                                    { i18n.t(tokens.labels.coverage.combinedFamilyMaximum, { combinedMaximum: helpers.formatNumber(dental.familyCombinedMaximum || 0) }) }
                                </Text>
                            </div>
                            :
                            null
                    }

                    <div>
                        {
                            dental.includeBasic ?
                                <React.Fragment>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.routineCareReimbursement }% Routine Care Reimbursement` }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.endodonticsReimbursement }% Endodontics Reimbursement` }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.periodonticsReimbursement }% Periodontics Reimbursement` }</Text>
                                </React.Fragment>
                                : null
                        }

                        {
                            dental.includeMajor ?
                                <React.Fragment>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.bridgeWorkReimbursement }% Bridge Work Reimbursement` }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.crownsReimbursement }% Crowns Reimbursement` }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.denturesReimbursement }% Dentures Reimbursement` }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.dentureRepairReimbursement }% Denture Repair Reimbursement` }</Text>
                                </React.Fragment>
                                : null
                        }

                        <Text small margin="5px 0px 0px 0px">{ `${ dental.unitsOfScaling } Units of Scaling` }</Text>
                        <Text small margin="5px 0px 0px 0px">{ `Routine Care Visit Every ${ dental.monthsToRecall } months` }</Text>

                        {
                            dental.hasDeductible ?
                                defineDeductibleVerbiage(dental)
                                : null
                        }

                        {
                            dental.includeOrthodontics ?
                                <React.Fragment>
                                    <Text small margin="5px 0px 0px 0px">{ `$${ helpers.formatNumber(dental.orthodonticLifetimeMax) } Orthodontic Lifetime Maximum` }</Text>
                                    <Text small margin="5px 0px 0px 0px">{ `${ dental.orthodonticReimbursement }% Orthodontics Reimbursement` }</Text>
                                    {
                                        isStudent ?
                                            <Text small margin="5px 0px 0px 0px">{ `Orthodontics Coverage Terminates at age ${ dental.orthodonticTerminationAge } or date of participants study if earlier.` }</Text>
                                            :
                                            <Text small margin="5px 0px 0px 0px">{ `Orthodontics Coverage Terminates at age ${ dental.orthodonticTerminationAge } or date of participants retirement if earlier.` }</Text>
                                    }
                                </React.Fragment>
                                : null
                        }

                        <Text small margin="5px 0px 0px 0px">{ `${ dental.monthsSurvivorBenefit } months survivor benefit` }</Text>
                        {
                            isStudent ?
                                <Text small margin="5px 0px 0px 0px">{ `Terminates at age ${ dental.terminationAge } or date of participants study if earlier.` }</Text>
                                :
                                <Text small margin="5px 0px 0px 0px">{ `Terminates at age ${ dental.terminationAge } or date of participants retirement if earlier.` }</Text>
                        }
                    </div>

                    <Text small bold margin="10px 0px 0px 0px">
                        Reimbursements of Dental procedures are limited according to the Annual Provincial Dental Fee Guide for general dentistry. If you have any questions regarding the use of  Dental Fee Guides, please contact your plan administrator.
                    </Text>
                </AccordionDetails>
            </Accordion>
        </div>
    );
}